import { DateField } from '@ovComponents/2-component/dateField/dateField';
import {
  type DepositScheduleOptions,
  resolveScheduledDateMinDate,
} from '@ovComponents/4-module/workflowCompletion/subSteps/utils/depositSchedule';
import type { useDepositSchedule } from '@ovComponents/4-module/workflowCompletion/subSteps/utils/useDepositSchedule';
import type { TransferContextData } from '@ovComponents/4-module/workflowCompletion/workflowTypes';
import { useLocalization } from '../../../../../../hooks/useLocalization';

export type DepositEftScheduledDateProp = {
  scheduledDate?: TransferContextData['scheduledDate'];
  options: DepositScheduleOptions & {
    scheduledDate?: { label?: unknown } | null;
  };
  schedule: Pick<
    ReturnType<typeof useDepositSchedule>,
    | 'transferDelayCheck'
    | 'isScheduledDateDisabled'
    | 'scheduledDateError'
    | 'scheduledDateErrorMessage'
  >;
  isTouched: boolean;
  onDateChange: (date: any) => void;
};

export const DepositEftScheduledDate = ({
  scheduledDate,
  options,
  schedule,
  isTouched,
  onDateChange,
}: DepositEftScheduledDateProp) => {
  const { translateBackendString } = useLocalization();

  return (
    <DateField
      fullWidth
      sx={{ mb: 2 }}
      dataTestId='scheduled-date'
      onChange={onDateChange}
      label={translateBackendString(options?.scheduledDate?.label)}
      minDate={resolveScheduledDateMinDate({
        options,
        transferDelayCheck: schedule.transferDelayCheck,
      })}
      shouldDisableDate={schedule.isScheduledDateDisabled}
      value={scheduledDate}
      error={schedule.scheduledDateError && isTouched}
      errorText={schedule.scheduledDateErrorMessage}
      autocomplete='off'
    />
  );
};
